import { c as _c } from "react/compiler-runtime";
import '@pc/styles/sidebar.css';
import ActiveLinkContainer from '@pc/components/molecules/sidebar/ActiveLinkContainer';
import RankingAndPickContainer from '@pc/components/molecules/sidebar/RankingAndPickContainer';
import ClientSideBar from './ClientSideBar';
function SideBar() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section id="sidebar" data-testid="sidebar" className="width-[228px] fixed top-[64px] bottom-0 left-0 z-30 bg-white"><div className="box-content h-full w-[228px]"><div className="relative z-[20] flex h-full w-full flex-col border-borderBg01 border-r bg-baseBg text-baseFg"><section className="scrollbar-custom overflow-auto"><ActiveLinkContainer /><RankingAndPickContainer /><ClientSideBar /></section></div></div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default SideBar;